import { render, staticRenderFns } from "./ActiveInstallsChart.vue?vue&type=template&id=22afcb11&"
import script from "./ActiveInstallsChart.vue?vue&type=script&lang=js&"
export * from "./ActiveInstallsChart.vue?vue&type=script&lang=js&"
import style0 from "./ActiveInstallsChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports